export type PillProps = {
  calculatedX: number
  barstackIndex: number
  bar: any
  top: number
  formatedOIData: any
  formatedOIValue: any
  dataType: "non-gcf" | "gcf"
  showSecondBar?: boolean
}

export default function Pill({
  calculatedX: barStart,
  barstackIndex,
  bar,
  top,
  formatedOIData,
  formatedOIValue,
  dataType,
  showSecondBar,
}: PillProps) {
  const isSmallScreen = bar.width < 160
  const pillWidth = bar.width / 1.2
  const pillCenter = pillWidth / 2
  const pillY = bar.y + top + bar.height / 3
  const title = dataType === "non-gcf" ? "OIBIA:" : "OI:"
  const charToSvgPixel = 5.416666666666667
  const textPosition =
    ((formatedOIValue.length + title.length) * charToSvgPixel) /
    (showSecondBar ? 3 : 4)
  return (
    <g>
      <rect
        fill="#18181A"
        rx="4"
        x={barStart + pillCenter - textPosition - 9.5}
        y={bar.y + top + bar.height / 3}
        width={(formatedOIValue.length + title.length) * charToSvgPixel + 17.5}
        height={16}
        key={`bar-stack-${barstackIndex}-${bar.index}`}
        style={{
          zIndex: 2,
        }}
      />
      <text
        fill="white"
        x={barStart + pillCenter - textPosition}
        y={pillY + (isSmallScreen ? 12 : 12.5)}
        style={{
          fontSize: pillWidth * 0.11 > 10 ? 10 : pillWidth * 0.11,
          zIndex: 9999,
        }}
      >
        {title}
        <tspan
          fill={formatedOIData[bar.index][bar.key] >= 0 ? "#75FBCF" : "#ED1D24"}
        >
          {" "}
          {formatedOIValue}
        </tspan>
      </text>
    </g>
  )
}
